/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ETransportNomenclatureVO } from './etransport-nomenclature-vo.model';

export class ETransportConfirmationTypeVoModel extends ETransportNomenclatureVO {}
